import React,{useEffect, useState} from 'react';
import { KoTitle, KoTable, KoButton, KoForm, KoModal, KoToast, KoNano, KoLoader, KoTooltips,  KoText, KoDateFormatter, KoTag, KoDescription} from "packages";
import KoIcon from '@kwapio/icons';
import {LEAVE_REQUEST} from './constant';
import styles from './leave.module.scss';
import { useDispatch } from 'react-redux';
import { add, remove } from 'shared/store/breadcrumbSlice';
import LeaveCurd from './leaveCurd';
import { ProfileAPI } from 'pages/profile/profile.service';
import { getLeaveCount } from 'shared/store/leaveCountSlice';
import { getApprovalCount } from 'shared/store/approvalCountSlice';

const MyLeaves = () => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [form] = KoForm.useForm();
  const [isOpen, setModal] = useState(false);
  const [currentRecord, setCurrentRecord] = useState();
  const [deleteLeaveRequest, setLeaveDeleteModal] = useState(false);
  const [leaveTypes , setLeaveTypes] = useState();
  const [leaveList, setLeaveList] = useState();
  const [cancelConfirm, setCancelConfirm] = useState(false);
  const [openSubmitModal, setSubmitModal] = useState(false);


  useEffect(()=>{
    dispatch(remove());
    getLeavesType();
    dispatch(add([
      {
        title: 'Home',
        path: 'home/leaves'
      },
      {
        title: 'Leaves'
      }
    ]));
    getLeaveRequests();
  },[]);


  const getLeaveRequests = () => {
    setLoading(true);
    ProfileAPI.getLeaveRequests().then(
      (data) => {
        setLoading(false);
        setLeaveList(data['leaves']);
      },
      (err) => {
        setLoading(false);
      }
    );
  };

  const getLeavesType = () => {
    setLoading(true);
    ProfileAPI.getLeaveTypes().then(
      (data) => {
        setLoading(false);
        setLeaveTypes(data?.leaveDays || []);
      }
            
    );
  };


  const handleFinish = (values) => {
    setLoading(true);
    if(!currentRecord?.leaveId){
      values['leaveId'] = KoNano('LEA');
    }
    values['status'] = 1;
    console.log("leave data api:",values);
    ProfileAPI.applyLeave(values, currentRecord?.leaveId).then(
      (data) => {
        getLeaveRequests();
        setLoading(false);
        dispatch(getLeaveCount());
        dispatch(getApprovalCount());
        getLeavesType();
        setModal(false);
        KoToast.success(`Leave ${currentRecord?.leaveId ? 'updated' : 'created'} successfully`);
      },
      (err) => {
        setLoading(false);
      }
    );
  };

  const canceLeaveRequest = () => {
    setLoading(true);
    let leaveObject = currentRecord;
    leaveObject['status'] = 0;
    ProfileAPI.applyLeave(leaveObject, leaveObject?.leaveId).then(
      (data) => {
        getLeaveRequests();
        setLoading(false);
        setCancelConfirm(false);
        setSubmitModal(false);
        dispatch(getApprovalCount());
        KoToast.success(`Request Cancelled successfully!`);
      },
      (err) => {
        setLoading(false);
      }
    );
  };

  const sendLeaveRequest = () => {
    setLoading(true);
    let leaveObject = currentRecord;
    leaveObject['status'] = 1;
    leaveObject['approver'] = currentRecord?.approver;
    leaveObject['leaveId'] = currentRecord?.leaveId;
    ProfileAPI.sendLeaveRequest(leaveObject).then(
      (data) => {
        getLeaveRequests();
        setLoading(false);
        setSubmitModal(false);
        dispatch(getApprovalCount());
        KoToast.success(`Request sent successfully!`);
      },
      (err) => {
        setLoading(false);
      }
    );
  };

  const handleFinishDelete = () => {
    setLoading(true);
    ProfileAPI.deleteLeaveRequest(currentRecord?.leaveId).then(
      (data) => {
        getLeaveRequests();
        setLoading(false);
        setLeaveDeleteModal(false);
        KoToast.success(`Leave deleted successfully!`);
        dispatch(getApprovalCount());
      },
      (err) => {
        setLoading(false);
      }
    );
  };

  const columnsRight = [{
    title: '',
    dataIndex: 'x',
    key: 'x',
    fixed: 'right',
    width: 80,
    render: (text, row) => {
      return <div className={`tableBtn columnsRight`} onClick={() => { form.resetFields(); setCurrentRecord(row); }}>
        {row?.status === 0 && <KoButton  color="primary" variant="solid" label='Send Request'  onClick={() => setSubmitModal(true)} />}
        {row?.status === 1 && <KoButton  color="danger" variant="solid" label='Cancel Request' onClick={() => setCancelConfirm(true)} />}
        {row?.status === 0 &&  <KoTooltips title={'Edit'}>
          <KoButton className={'btn'} iconBtn={true} icon={<KoIcon width={14} height={14} name={'EditOutlined'} />} onClick={() => setModal(true)} />
        </KoTooltips>}
        {row?.status === 0 &&  <KoTooltips title={'Delete'}>
          <KoButton className={'btn'} iconBtn={true} icon={<KoIcon width={14} height={14} name={'DeleteOutlined'} />} onClick={() => setLeaveDeleteModal(true)} />
        </KoTooltips>}
      </div>;
    }
  }];

  return (
    <div className={styles.wrapper}>
      {loading && <KoLoader/>}
      <div className={`${styles.leaveBalance} tableCard`}>
        <div className={styles.header}>
          <KoTitle text='Leave Request' level={4} />
          <div className={styles.addLeave}>
            <KoButton onClick={() => setModal(true)} label='Add Leave' type='primary' />
          </div>
        </div>
        <div className={styles.leaveBalanceTable}>
          <KoTable rowKey='leaveRequest' extraColumnsRight={columnsRight} data={{ columns: LEAVE_REQUEST, rows: leaveList }} maxHeight={100} />
        </div>
      </div>
      <KoTitle text='Leave Balances' className={styles.leaveBalance} level={4}/>
      <div className={`${styles.leaveBalanceCard}`}>
        {leaveTypes?.map((modulex) => (
          <div  className={styles.card } key={modulex.leaveId}>
            <div className={styles.year}>
              {modulex.year}
            </div>
            <KoTitle ellipsis={true} key={modulex.leaveId} text={`${modulex.name} `} level={5} />
            <KoDescription ellipsis={true} className={styles.description}  text={modulex.description} />
            <div className={styles.tags}>
              <KoTag color='approved' custom={true} iscount={false} value={`Consumed - ${modulex.leaveTaken ?`${modulex.leaveTaken}` : 0}`} />
              <KoTag color='pending' custom={true} iscount={false} value={`Available - ${modulex.remainingDays ?` ${modulex.remainingDays}` : 0}`}/>
              <KoTag color='draft' custom={true} iscount={false} value={`Annual Quota - ${modulex.totalDays ?` ${modulex.totalDays}` : 0}`}  />
            </div>
          </div>
        ))}
      </div>
      <KoModal
        title={`Apply Leave`}
        centered
        open={isOpen}
        afterClose={() => {setCurrentRecord();}}
        handleOk={() => { setCurrentRecord(); setModal(false); }}
        onClose={() => { setCurrentRecord(); setModal(false); }}
        width={'60%'}
        footer={[
          <KoButton key='cancel' label='Cancel' onClick={() => setModal(false)} />,
          <KoButton key='create' type='primary' label={currentRecord?.holidayId ? `Apply` : `Apply`}
            onClick={() => form.submit()} />
        ]}
      >
        <LeaveCurd leaveTypes={leaveTypes} form={form} initialValues={currentRecord} handleFinish={handleFinish} />
      </KoModal>

      <KoModal
        title={`Cancel Leave?`}
        centered
        open={cancelConfirm}
        afterClose={() => { setCurrentRecord(); }}
        handleOk={() => { setCurrentRecord(); setCancelConfirm(false); }}
        onClose={() => { setCurrentRecord(); setCancelConfirm(false); }}
        width={580}
        footer={[
          <KoButton key='cancel' label='Cancel' onClick={() => setCancelConfirm(false)} />,
          <KoButton key='reset' loading={loading} color="danger" variant="solid" type='primary' label='Cancel Leave' onClick={() => canceLeaveRequest(currentRecord)} />
        ]}
      >
        {loading && <KoLoader circle={false} />}
        <div className={styles.suspend}>
          <KoTitle level={5} text={`Are you sure you want to cancel this Leave Request?`} />
          <div className={styles.dates}>
            <KoDateFormatter data={currentRecord?.start} format="DD-MMM-YYYY" />
            <KoText text=" to " />
            <KoDateFormatter data={currentRecord?.end} format="DD-MMM-YYYY" />
            <KoText text={` - ${currentRecord?.reason} (${currentRecord?.totaldays} days)`} />
          </div>
        </div>
      </KoModal>

      <KoModal
        title={`Submit Leave?`}
        centered
        open={openSubmitModal}
        afterClose={() => { setCurrentRecord(); }}
        handleOk={() => { setCurrentRecord(); setSubmitModal(false); }}
        onClose={() => { setCurrentRecord(); setSubmitModal(false); }}
        width={580}
        footer={[
          <KoButton key='cancel' label='Cancel' onClick={() => setSubmitModal(false)} />,
          <KoButton key='reset' loading={loading} type='primary' label='Request Leave' onClick={() => sendLeaveRequest(currentRecord)} />
        ]}
      >
        {loading && <KoLoader circle={false} />}
        <div className={styles.suspend}>
          <KoTitle level={5} text="Are you sure you want to submit this leave request?" />
          <div className={styles.dates}>
            <KoDateFormatter data={currentRecord?.start} format="DD-MMM-YYYY" />
            <KoText text=" to " />
            <KoDateFormatter data={currentRecord?.end} format="DD-MMM-YYYY" />
            <KoText text={` - ${currentRecord?.reason} (${currentRecord?.totaldays} days)`} />
          </div>
        </div>
      </KoModal>

      <KoModal
        title={`Delete Leave?`}
        centered
        open={deleteLeaveRequest}
        afterClose={() => { setCurrentRecord(); }}
        handleOk={() => { setCurrentRecord(); setLeaveDeleteModal(false); }}
        onClose={() => { setCurrentRecord(); setLeaveDeleteModal(false); }}
        width={580}
        footer={[
          <KoButton key='cancel' label='Cancel' onClick={() => setLeaveDeleteModal(false)} />,
          <KoButton key='reset' color="danger" variant="solid" type='primary' label='Delete' onClick={() => handleFinishDelete()} />
        ]}
      >
        {loading && <KoLoader circle={false} />}
        <div className={styles.suspend}>
          <KoTitle level={5} text={`Are you sure you want to delete this Leave?`} />
          <KoText text={`This action is irreversible, and it will result in the removal of their associated data.`} />
        </div>
      </KoModal>

    </div>
  );
};

export default MyLeaves;
